module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1265"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1265"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30809",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};